import {userConstants} from '../../_constants';

export function invoiceItems(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_INVOICE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case userConstants.GET_INVOICE_SUCCESS:
      return {
        ...state,
        ...action.data,
        loading: false,
      };
    case userConstants.GET_INVOICE_FAILURE:
      return {
        error: action.error,
      };

    default:
      return state;
  }
}
